import { IntegrityMonitorRealTimePanelView } from '../view/IntegrityMonitorRealTimePanelView';
import { templateIntegrityMonitorRealTimePanel } from '../view/template';
import { IntegrityMonitorRealTimePanelRepository } from '../repository/IntegrityMonitorRealTimePanelRepository';
import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorRealTimePanelWebComponent } from '..';
import { IntegrityMonitorRealTimePanelWebComponentSchema } from '../types';
import { PolicyRuleSetsSectionEvents } from '../../integrityMonitorPolicyRuleSetsSection/types';
import { RadioEvent } from '../../../../../ui/gzRadio/types';

export class IntegrityMonitorRealTimePanelController extends BaseWebComponentController {
  public component: IntegrityMonitorRealTimePanelWebComponent;
  public dataRepository: IntegrityMonitorRealTimePanelRepository;
  public view: IntegrityMonitorRealTimePanelView;
  public viewConstructor: typeof IntegrityMonitorRealTimePanelView;
  public dataRepositoryConstructor: typeof IntegrityMonitorRealTimePanelRepository;

  constructor(component: IntegrityMonitorRealTimePanelWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrityMonitorRealTimePanelView,
      viewTemplate: templateIntegrityMonitorRealTimePanel,
      dataRepositoryConstructor: IntegrityMonitorRealTimePanelRepository,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$enabledFormField,
        event: 'change',
        callback: this.onEnabledCheckboxChange,
      },
      {
        element: this.view.dom.$ruleProcessingModeFormField,
        event: RadioEvent.SELECTION_CHANGED,
        callback: this.onRuleProcessingModeChange,
      },
      {
        element: this.view.dom.$ruleSetsSection,
        event: PolicyRuleSetsSectionEvents.RULE_SETS_SELECTION_CHANGE,
        callback: this.onRuleSetsSectionChange,
      },
    ];
  }

  async getDataForView(): Promise<IntegrityMonitorRealTimePanelWebComponentSchema> {
    const formValue = this.component.getFormValue();

    return { formValue } as IntegrityMonitorRealTimePanelWebComponentSchema;
  }

  private onEnabledCheckboxChange(event) {
    const newValue = event.detail.checked;
    this.view.setDisabledChildren(!newValue);
    this.component.onFormFieldChange('enabled', newValue);
  }

  private onRuleProcessingModeChange(event): void {
    const newValue = event.detail.selectedValue;
    this.component.onFormFieldChange('ruleProcessingMode', newValue);
  }

  private onRuleSetsSectionChange(event: CustomEvent) {
    const newValue = event.detail.selectedRuleSetIds;
    this.component.onFormFieldChange('ruleSetIds', newValue);
  }
}
